import { ApplyButton } from 'components/ApplyButton/ApplyButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { SaveButton } from 'components/SaveButton/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { OrgDashboardApiJob } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiJob';

type Props = {
  job: ApiJob | OrgDashboardApiJob;
};

export function ViewJobActionButtons({ job }: Props) {
  const { id, hasAts, name, type, url, org } = job;

  return (
    <ListingViewActionButtons>
      <ApplyButton atsIsEnabled={hasAts} listingId={id} size="medium" />

      <SaveButton
        listingId={id}
        listingType={type}
        listingName={name}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        hasAts={hasAts}
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />
    </ListingViewActionButtons>
  );
}
